export default "__VITE_ASSET__qDB3WbN9__"